// Vendor snippets on Odin pages that throw uncaught errors we cannot fix
// (CookieYes, Zendesk, Searchable, Proof). Matches distinctive vendor
// hostnames / full names only. Deliberately NOT short substrings: `cky-` also
// matches `sticky-…` and `\bzE\b` matches the routine minified identifier `ze`,
// either of which would swallow a genuine first-party error by coincidence.
//
// Shared by the Cypress visual specs (`cypress/support/visual.ts`) and PostHog
// error tracking (`src/util/posthog/exceptions.ts`), so it must stay free of
// runtime imports.
export const THIRD_PARTY_SCRIPT_ERROR_PATTERN = /cookieyes|zdassets|zendesk|searchableanalytics|useproof|zE is not defined/i
